import { render, staticRenderFns } from "./AboutMethod.vue?vue&type=template&id=d83f2a80"
import script from "./AboutMethod.vue?vue&type=script&lang=js"
export * from "./AboutMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports